module.exports = __webpack_public_path__ + "assets/img/map.08d993a3.png";